export default "__VITE_ASSET__CCnWSdtY__"